import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './otp.less';

const OtpInput = ({ onChange, disabled, errorKey }) => {
  const [values, setValues] = useState(['', '', '', '', '', '']);
  const inputs = useRef([]);

  useEffect(() => {
    if (errorKey) {
      setValues(['', '', '', '', '', '']);
      onChange('');
      if (inputs.current[0]) inputs.current[0].focus();
    }
  }, [errorKey]);

  const updateValues = (newValues) => {
    setValues(newValues);
    onChange(newValues.join(''));
  };

  const handleChange = (index, e) => {
    const { value } = e.target;
    if (value && !/^\d$/.test(value)) return;

    const newValues = [...values];
    newValues[index] = value;
    updateValues(newValues);

    if (value && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !values[index] && index > 0) {
      const newValues = [...values];
      newValues[index - 1] = '';
      updateValues(newValues);
      inputs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (!pastedData) return;

    const newValues = ['', '', '', '', '', ''];
    pastedData.split('').forEach((digit, i) => {
      newValues[i] = digit;
    });
    updateValues(newValues);

    const focusIndex = Math.min(pastedData.length, 5);
    inputs.current[focusIndex].focus();
  };

  return (
    <div className="otp-input-container">
      {values.map((value, index) => (
        <input
          // eslint-disable-next-line react/no-array-index-key
          key={`otp-${index}`}
          id={`otp-input-${index}`}
          aria-label={`Verification code digit ${index + 1}`}
          ref={(el) => {
            inputs.current[index] = el;
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]"
          maxLength="1"
          className="otp-input-box"
          value={value}
          disabled={disabled}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={index === 0 ? handlePaste : undefined}
          autoComplete={index === 0 ? 'one-time-code' : 'off'}
        />
      ))}
    </div>
  );
};

OtpInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  errorKey: PropTypes.number,
};

OtpInput.defaultProps = {
  disabled: false,
  errorKey: 0,
};

export default OtpInput;
